import { PROP_LIBRARY_BINARY_PUBLIC_PATH } from "./propLibraryPaths";

export async function loadPropLibraryGitBinaryBrowser(): Promise<Uint8Array> {
  const response = await fetch(PROP_LIBRARY_BINARY_PUBLIC_PATH);
  return new Uint8Array(await response.arrayBuffer());
}
